import { render, staticRenderFns } from "./Layout_GLYF_login.vue?vue&type=template&id=0c17981e&scoped=true"
import script from "./Layout_GLYF_login.vue?vue&type=script&lang=js"
export * from "./Layout_GLYF_login.vue?vue&type=script&lang=js"
import style0 from "./Layout_GLYF_login.vue?vue&type=style&index=0&id=0c17981e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c17981e",
  null
  
)

export default component.exports